import { render, staticRenderFns } from "./KioskIcon.vue?vue&type=template&id=119c1b96&scoped=true"
import script from "./KioskIcon.vue?vue&type=script&lang=js"
export * from "./KioskIcon.vue?vue&type=script&lang=js"
import style0 from "./KioskIcon.vue?vue&type=style&index=0&id=119c1b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119c1b96",
  null
  
)

export default component.exports